import React from "react";
import { Table, Tag, Typography } from "antd";
import { pretty, splitCreateAfter } from "utils/auditLogUtils";
import { CreateArraySection } from "./CreateArraySection";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

export type DeletedRow = { field: string; value: any };

export const DeletedChangesTable: React.FC<{ record?: any }> = ({ record }) => {
  const { t } = useTranslation();
  // Treat the record like a "create after" snapshot to reuse splitting logic
  let scalarRows: DeletedRow[] = [];
  let arraySections: Array<{ key: string; items: any[] }> = [];

  if (record && typeof record === "object") {
    const split = splitCreateAfter(record); // splits into scalar rows + array sections
    scalarRows = split.scalarRows;
    arraySections = split.arraySections;
  }

  const columns = [
    {
      title: t("Field"),
      dataIndex: "field",
      key: "field",
      render: (f: string) => <Text code>{t("auditLog." + f)}</Text>,
      width: "50%",
      ellipsis: true,
    },
    {
      title: t("Value"),
      dataIndex: "value",
      key: "value",
      render: (v: any) =>
        Array.isArray(v) ? (
          <span>{v.map((x, i) => <Tag color="processing" key={i}>{t(pretty(x)) || pretty(x)}</Tag>)}</span>
        ) : (
          <Tag color="processing">{t(pretty(v)) || pretty(v)}</Tag>
        ),
    },
  ];

  return (
    <div>
      {scalarRows.length ? (
        <Table
          rowKey={(r) => r.field}
          dataSource={scalarRows}
          columns={columns}
          pagination={false}
          size="small"
        />
      ) : (
        <Text type="secondary">No values</Text>
      )}

      {/* Only show array sections that have items */}
      {arraySections
        .filter((section) => Array.isArray(section.items) && section.items.length > 0)
        .map((section) => (
          <CreateArraySection key={section.key} title={section.key} items={section.items} />
        ))}
    </div>
  );
};
